import { on } from "delegated-events";
import Cookies from "js-cookie";

const showModal = async (data) => {
  const styledForm = await import(/* webpackChunkName: "components-modal-styled-form" */ "@components/styled-form");
  const { default: modal } = await import(/* webpackChunkName: "components-modal" */ "@scripts/components/modal");

  modal.openModal({
    type: "content",
    url: data.formModalEndpoint,
    useCustomClose: true,
  });

  on("modal:populate", "html", () => {
    const form = document.querySelector(".request-a-demo-form");

    if (form) {
      styledForm.setupForm(form);

      Cookies.set("kredosai_form_modal_seen", true, { expires: 1 });
    }
  });
};

export default {
  init: () => {
    const data = JSON.parse(document.getElementById("app-data-json").textContent);

    if (data && data.formModalEnabled) {
      if (Cookies.get("kredosai_form_modal_seen")) {
        return;
      }

      const waitSeconds = data.formModalWaitTime || 120;
      const waitMilliseconds = waitSeconds * 1000;

      let startTime = parseInt(Cookies.get("kredosai_form_modal_start"));

      if (!startTime) {
        startTime = parseInt(new Date().getTime());
        Cookies.set("kredosai_form_modal_start", startTime, { expires: 1 });
      }

      const interval = setInterval(() => {
        const nowTime = new Date().getTime();
        const timeDiff = nowTime - startTime;

        if (timeDiff >= waitMilliseconds) {
          showModal(data);
          clearInterval(interval);
        }
      }, 1000);
    } else {
      Cookies.remove("kredosai_form_modal_start");
      Cookies.remove("kredosai_form_modal_seen");
    }
  },
};
